import ErrorWithToast from "./ErrorWithToast";

class BoletoNotFound extends ErrorWithToast{
  constructor() {
    super("Não encontramos seu Boleto");
  }
}

export default BoletoNotFound;
